/* Domovoi · feedback, the always-loaded half (D3.2). In site.js, so on every page.

   Keeps a short memory of what just happened — the last 20 product events and
   the last 10 errors — so a report can say what led up to it. Opens the sheet
   (the feedback bundle, /assets/feedback.js, loaded the first time it's
   needed) from the account menu's "Send feedback" or, in the app, a shake
   (dv-shake, from the native side). */

var recent = [];   // { e, at, p? }
var errors = [];   // { m, at, src? }
var MAX_E = 20, MAX_ERR = 10;

function keep(list, item, max) { list.push(item); if (list.length > max) list.shift(); }

// Product events: wrap DVTrack once it exists (analytics.js defines it first in site.js).
function wrapTrack() {
  var orig = window.DVTrack;
  if (typeof orig !== 'function' || orig.__dvFeedback) return;
  var wrapped = function (name, props) {
    try {
      var p = {};
      if (props && typeof props === 'object') {
        // only the short, non-personal bits: product, tab, kind, counts
        ['product', 'tab', 'kind', 'action', 'provider', 'where', 'result', 'media_type', 'decision'].forEach(function (k) {
          if (props[k] != null && typeof props[k] !== 'object') p[k] = String(props[k]).slice(0, 40);
        });
      }
      keep(recent, { e: String(name).slice(0, 60), at: Date.now(), p: p }, MAX_E);
    } catch (e) { /* never get in the way of analytics */ }
    return orig.apply(this, arguments);
  };
  wrapped.__dvFeedback = true;
  window.DVTrack = wrapped;
  // caught errors too (DVTrackError), not only the ones that reach window
  var origErr = window.DVTrackError;
  if (typeof origErr === 'function' && !origErr.__dvFeedback) {
    var wrappedErr = function (err, props) {
      try { onError(err && err.message ? err.message : String(err), props && props.where); } catch (e) { /* ignore */ }
      return origErr.apply(this, arguments);
    };
    wrappedErr.__dvFeedback = true;
    window.DVTrackError = wrappedErr;
  }
}

function onError(msg, src) {
  keep(errors, { m: String(msg || 'error').slice(0, 300), at: Date.now(), src: src ? String(src).slice(0, 120) : undefined }, MAX_ERR);
}

var loading = null;
function loadSheet() {
  if (window.DVFeedbackSheet) return Promise.resolve(window.DVFeedbackSheet);
  if (!loading) {
    loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = '/assets/feedback.js';
      s.async = true;
      s.onload = function () { window.DVFeedbackSheet ? resolve(window.DVFeedbackSheet) : reject(new Error('feedback sheet missing')); };
      s.onerror = function () { loading = null; reject(new Error('feedback sheet failed to load')); };
      document.head.appendChild(s);
    });
  }
  return loading;
}

function open(opts) {
  if (document.documentElement.classList.contains('dv-fb-open')) return;
  return loadSheet().then(function (sheet) {
    sheet.open({ recent: recent.slice(), errors: errors.slice(), from: (opts && opts.from) || 'menu' });
  }).catch(function (e) { onError(e.message, 'feedback'); });
}

if (typeof window !== 'undefined') {
  wrapTrack();
  // analytics.js may define DVTrack after us on some pages
  setTimeout(wrapTrack, 0);
  window.addEventListener('error', function (e) { onError(e.message, e.filename); });
  window.addEventListener('unhandledrejection', function (e) {
    var r = e.reason; onError(r && (r.message || r.toString && r.toString()) || 'unhandled rejection', 'promise');
  });
  window.addEventListener('dv-shake', function () { open({ from: 'shake' }); });
  window.DVFeedback = { open: open };
}

export var DVFeedback = typeof window !== 'undefined' ? window.DVFeedback : null;
